
import React, { useState, useEffect } from 'react';
import '../competitive/../header/style.css';
import { Header } from "../competitive";
import { AdminNavbar } from "../competitive";
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME } from '../../../constants/apiConstants';

function EnquiriesLiast() {
    const navigate = useNavigate();
    const [roleList, setRoleList] = useState([]); // State to hold competitive exam data

    useEffect(() => {
        fetchRoles();
    }, []);

    const fetchRoles = async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/getEnquiryData`, {
                headers: {
                    "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`,
                    "Content-Type": "application/json",
                },
            });
            console.log(response.data);
            setRoleList(response.data); // Store response data in state
        } catch (err) {
            console.error("Error fetching roles:", err);
        }
    };

    return (
        <div>
            <Header />
            <div className="main-container">
                <AdminNavbar />
                <div className="main">
                    <div className="report-container">
                        <div className="report-header">
                            <h1 className="recent-Articles">Enquiries List</h1>
                            {/* <Link className="recent-Articles" to={`/admin/competitiveCreateRole`}>
                                Create New Competitive Exam
                            </Link> */}
                        </div>

                        <div className="report-body">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>Message</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {roleList.length > 0 ? (
                                        roleList.map((item, index) => (
                                            <tr key={item.id}>
                                                <td>{index + 1}</td>
                                                <td>{item.name}</td>
                                                <td>{item.email}</td>
                                                <td>{item.phone}</td>
                                                <td>{item.message}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="10" className="text-center">
                                                No records found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EnquiriesLiast;
